export * from './image-component-config.interface';
